import { removeFromCalendarButton } from './MeetingCancellationInfo.locstring.json';
import loc from 'owa-localize';
import MeetingActionButton from './MeetingActionButton';
import removeCancelledMeetingFromCalendar from '../actions/removeCancelledMeetingFromCalendar';
import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';
import { observer } from 'mobx-react-lite';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { ControlIcons } from 'owa-control-icons';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';

import * as React from 'react';

const styles = require('./MeetingMessageActions.scss');

export interface MeetingCancellationInfoProperties {
    item: MeetingCancellationMessageType;
    entrySource: MeetingMessageActionEntrySource;
    groupId?: string;
}

export default observer(function MeetingCancellationInfo(props: MeetingCancellationInfoProperties) {
    function onRemoveFromCalendarClicked() {
        removeCancelledMeetingFromCalendar(props.item, props.entrySource);
    }

    return props.groupId || props.item.IsOrganizer ? null : (
        <FocusZone direction={FocusZoneDirection.horizontal} className={styles.container}>
            <MeetingActionButton
                text={loc(removeFromCalendarButton)}
                onClick={onRemoveFromCalendarClicked}
                iconProps={{ iconName: ControlIcons.RemoveEvent }}
            />
        </FocusZone>
    );
});
